import { render, staticRenderFns } from "./ArticleLoading.vue?vue&type=template&id=6eb827d3"
import script from "./ArticleLoading.vue?vue&type=script&lang=js"
export * from "./ArticleLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports